const ICON_SNAP = ({ color = "#fff", strokeWidth = 3, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <g transform="rotate(-45 17.792 30.863) scale(1.10405)">
      <path
        d="M24.473-.027v-1.247M26.197.718l.882-.882M26.898 2.413h1.248M22.062 2.398h-1.247M22.772.695l-.882-.882"
        style={{
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.59911,
          stroke: color,
        }}
      />
      <path
        d="m24.5 4.046-1.71 3.667h.001l1.297-.358v1.821h.824V7.355l1.297.358z"
        style={{
          fillRule: "evenodd",
          fill: color,
          paintOrder: "markers fill stroke",
        }}
      />
      <circle
        cx={24.473}
        cy={2.413}
        r={1.122}
        style={{
          fill: color,
          paintOrder: "markers fill stroke",
        }}
      />
    </g>
  </svg>
);

export default ICON_SNAP;
